import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
  },

  headerRoot: {
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderBottom: theme.palette.border.default,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 20px',

    '& .MuiCardHeader-content': {
      '& .MuiCardHeader-title': {
        color: '#FFFFFF',
        fontSize: theme.typography.appFontSize,
        fontWeight: 500,
        textTransform: 'inherit',
      },
    },
  },

  headerEmpty: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },

  headerFilled: {
    backgroundColor: `${theme.palette.success.main} !important`,
  },

  content: {
    padding: '0',
    '& .tableSelectableList .rdt_Pagination > span:nth-child(3)': {
      display: 'none',
    },
  },
}));

const customStyles = {
  headRow: {
    style: {
      backgroundColor: '#FBFBFB',
      border: 'none',
      minHeight: '3.75rem',
    },
  },
  headCells: {
    style: {
      color: '#2C2C2E',
      fontSize: 14,
      fontWeight: 500,
    },
  },
  rows: {
    style: {
      borderBottom: '1px solid #E5E5E5',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#FBFBFB',
      borderTop: '1px solid #E5E5E5 !important',
      borderBottomColor: '#E5E5E5 !important',
    },
  },
  pagination: {
    style: {
      border: 'none',
    },
  },
};

export { useStyles, customStyles };
